import React from "react";

export const Paragraph = ({block}) => {
  return <p dangerouslySetInnerHTML={{__html: block.data.text}}/>
}